"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../basics/Grid"));
var Button_1 = __importDefault(require("../../basics/Button"));
var typography_1 = require("../../typography");
var forms_1 = require("../../forms");
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var Icon_1 = __importDefault(require("../../basics/Icon"));
var TextButton_1 = __importDefault(require("../TextButton"));
var BottomDrawer_1 = __importDefault(require("./components/BottomDrawer"));
var styles_1 = require("./styles");
var VS_1_AMOUNT = { small: 8, medium: 8, large: 8 };
function FilterGroup(_a) {
    var name = _a.name, values = _a.values, filters = _a.filters, sorting = _a.sorting, onChange = _a.onChange, onReset = _a.onReset, numResults = _a.numResults, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, commonProps = __rest(_a, ["name", "values", "filters", "sorting", "onChange", "onReset", "numResults", "isLoading"]);
    var _c = __read(react_1.default.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read(react_1.default.useState(values), 2), state = _d[0], setState = _d[1];
    var handleChangeMobile = react_1.default.useCallback(function (name, value) {
        setState(function (s) {
            var _a;
            return (__assign(__assign({}, s), (_a = {}, _a[name] = value, _a)));
        });
    }, [setState]);
    var handleChange = react_1.default.useCallback(function (name, value) {
        var _a;
        onChange(__assign(__assign({}, values), (_a = {}, _a[name] = value, _a)));
    }, [onChange, values]);
    var handleClickApply = react_1.default.useCallback(function () {
        onChange(state);
        setIsOpen(false);
    }, [onChange, setIsOpen, state]);
    var handleClickReset = react_1.default.useCallback(function () {
        onReset();
        setIsOpen(false);
    }, [onReset, setIsOpen]);
    var hasFilters = react_1.default.useMemo(function () { return Object.values(values).some(function (value) { return value !== undefined; }); }, [values]);
    var title = "Filters".concat(!!sorting ? "and sorting" : '');
    var filtersArray = react_1.default.useMemo(function () { return Object.entries(filters); }, [filters]);
    var sortingArray = react_1.default.useMemo(function () { return (sorting ? Object.entries(sorting) : undefined); }, [sorting]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "FilterGroup" }, commonProps),
        react_1.default.createElement(Grid_1.default, null,
            react_1.default.createElement(Grid_1.default.Cell, { span: "full" },
                react_1.default.createElement(styles_1.Desktop, null,
                    react_1.default.createElement(styles_1.Inner, null,
                        react_1.default.createElement(styles_1.InputWrapper, null,
                            filtersArray.map(function (_a) {
                                var _b = __read(_a, 2), key = _b[0], options = _b[1];
                                return (react_1.default.createElement(forms_1.SelectInput, { id: "FilterGroup_".concat(name, "_").concat(key), key: key, name: key, ariaLabel: key, options: options, value: values[key] || values[key], onChange: function (value) { return handleChange(key, value); } }));
                            }),
                            hasFilters && (react_1.default.createElement(TextButton_1.default, { color: "BLUE_50", hoverColor: "BLUE_60", onClick: handleClickReset },
                                react_1.default.createElement(Icon_1.default, { name: "close" }))),
                            !isLoading && (react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_70", inline: true },
                                numResults,
                                " results"))),
                        sortingArray && (react_1.default.createElement(styles_1.InputWrapper, null, sortingArray.map(function (_a) {
                            var _b = __read(_a, 2), key = _b[0], options = _b[1];
                            return (react_1.default.createElement(forms_1.SelectInput, { id: "FilterGroup_".concat(name, "_").concat(key), key: key, name: key, ariaLabel: key, options: options, value: values[key], onChange: function (value) { return handleChange(key, value); } }));
                        }))))),
                react_1.default.createElement(styles_1.Mobile, null,
                    react_1.default.createElement(styles_1.InputWrapper, null,
                        react_1.default.createElement(Button_1.default, { onClick: function () { return setIsOpen(true); }, version: "outline" }, "Filters & sorting"),
                        react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_70", inline: true },
                            numResults,
                            " results"))))),
        isOpen && (react_1.default.createElement(BottomDrawer_1.default, { title: title, onClose: function () { return setIsOpen(false); }, footer: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.InputWrapper, null,
                    react_1.default.createElement(Button_1.default, { onClick: handleClickApply }, "Apply"),
                    react_1.default.createElement(Button_1.default, { onClick: handleClickReset, version: "outline" }, "Reset"))) },
            react_1.default.createElement(VerticalSpacer_1.default, { amount: VS_1_AMOUNT },
                filtersArray.map(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], options = _b[1];
                    return (react_1.default.createElement(forms_1.SelectInput, { id: "FilterGroup_".concat(name, "_").concat(key), ariaLabel: name, key: key, name: key, options: options, value: state[key], onChange: function (value) { return handleChangeMobile(key, value); } }));
                }),
                sortingArray &&
                    sortingArray.map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], options = _b[1];
                        return (react_1.default.createElement(forms_1.SelectInput, { id: "FilterGroup_".concat(name, "_").concat(key), key: key, name: key, ariaLabel: name, options: options, value: state[key], onChange: function (value) { return handleChangeMobile(key, value); } }));
                    }))))));
}
exports.default = FilterGroup;
